import Loader from '../../../Loader/Loader';
import React, { useState, useEffect, useRef } from 'react';
import { Redirect, Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import {

    reqGET,
    reqPOST,
    reqDELETE,
    reqPUT,
    reqFILE,
    set_language,
    content_language,
    translate,
    check_interface,

} from '../../../../Utils';
import { api_crud_base, data_interface, api_list_route, endpoints, api_crud_route } from './Config';
import "../../../../assets/dataTable.css";
import UseSidebar from '../../../../UseSidebar';
import { getTokenInfo } from '../../../../UseToken';
import Hosts, { companycode } from '../../../../Hosts';
import { object_type } from './Config';
import ReactQuill from 'react-quill';
import { language } from "./Language";
import { color } from "../../../WEBContent/Color";
import { icon } from '../../../WEBContent/Icon';

export default function View(props) {

    const [isloading, setLoading] = useState(true);
    const [, set_dados] = useState(null)
    const dados = useRef(null)
    const [isRedirect, /*setRedirect*/] = useState(false);

    const articles = useRef([]);
    const reviewers = useRef([]);

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

    const [tarefaId, setTarefaId] = useState('');
    const [nomeTarefa, setNomeTarefa] = useState('');
    const [selectedPrioridade, setSelectedPrioridade] = useState('')
    const [selectedEstado, setSelectedEstado] = useState('')
    const [selectedDataInicio, setSelectedDataInicio] = useState('')
    const [selectedDataLimite, setSelectedDataLimite] = useState('')
    const [refresh, setRefresh] = useState(0)

    //const [refresh, setRefresh] = useState(0);    
    const [colaboradores, setColaboradores] = useState([]);
    const [nomeResponsaveis, setResponsaveisNome] = useState('')
    const [nomeMonitor, setNomeMonitor] = useState('')
    const [userId, setUserId] = useState(null);
    const [profile, setProfile] = useState(null);
    const [name, setName] = useState(null);  

    //Departamento
    const [departamentos, setDepartamentos] = useState([]);
    const [selectedDepartamento, setSelectedDepartamento] = useState('');
    const [departamentoid, setSelectedDepartamentoId] = useState(dados.current?.info?.departamentoid || null);

    // Responsavel   
    const [allResponsaveis, setAllResponsaveis] = useState([]);
    const [responsaveisPorDepartamento, setResponsaveisPorDepartamento] = useState({});  
    const [data, setData] = useState([]);
    const permissions = useRef(null);
    const { pathname } = useLocation()
    const [document_state_list, set_document_state_list] = useState([])   

    const get_info = async () => {
        //await reqGET(api_list_route(getTokenInfo().companycode))
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined)
                    setData(res.data);
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            let aux_document_state = [
                {
                    id: 0,
                    label: 'Em edição'
                },
                {
                    id: 1,
                    label: 'Aguarda aprovação'
                },
                {
                    id: 2,
                    label: 'Em revisão'
                },
                {
                    id: 3,
                    label: 'Aprovado'
                },
                {
                    id: 4,
                    label: 'Obsoleto'
                },
                {
                    id: 5,
                    label: 'Eliminado'
                }
            ]
            set_document_state_list(aux_document_state)

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    const styles = {
        container: {
            maxWidth: "650px",
            margin: "16px auto",
            padding: "16px",
            background: "#f8f9fa",
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        },
        header: {
            background: "#2C3E50",
            padding: "12px 16px",
            borderRadius: "8px",
            textAlign: "center",
            fontSize: "1.3em",
            fontWeight: "bold",
            color: "white",
            boxShadow: "0 4px 8px rgba(102, 126, 234, 0.3)",
            marginBottom: "16px",
            letterSpacing: "0.3px",
        },
        section: {
            background: "white",
            padding: "12px",
            borderRadius: "8px",
            marginBottom: "10px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
        },
        sectionTitle: {
            marginBottom: "10px",
            fontSize: "0.75rem",
            fontWeight: "700",
            textTransform: "uppercase",
            letterSpacing: "0.8px",
            color: "#888",
            paddingLeft: "2px",
        },
        row: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "8px",
            marginBottom: "8px",
        },
        gridItem: {
            background: "#f8f9ff",
            padding: "10px 12px",
            borderRadius: "8px",
            border: "1px solid #eef0f8",
            transition: "box-shadow 0.2s",
        },
        gridLabel: {
            fontWeight: "600",
            color: "#999",
            marginBottom: "4px",
            fontSize: "0.72rem",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
        },
        gridValue: {
            color: "#222",
            fontSize: "0.92rem",
            fontWeight: "500",
        },
        footer: {
            textAlign: "right",
            fontSize: "0.95em",
            fontWeight: "bold",
            padding: "12px",
        },
    };  

    const getMonitorNome = (monitorArray) => {
        if (!Array.isArray(monitorArray) || monitorArray.length === 0) return 'Carregando...';
        const monitorLabels = monitorArray.map(monitor => monitor.label);
        return monitorLabels.join(', ');
    };

    const getResponsaveisNome = (responsaveisArray) => {
        if (!Array.isArray(responsaveisArray) || responsaveisArray.length === 0) return 'Nenhum responsável';
        const responsaveisLabels = responsaveisArray.map(responsavel => responsavel.label);
        return responsaveisLabels.join(', ');
    };

    useEffect(() => {
        const storedData = localStorage.getItem('token');
        const data = JSON.parse(storedData);
        if (storedData) {
            const data = JSON.parse(storedData);
            if (data.user_info) {
                if (data.user_info.user_info) {

                } else {

                    setProfile(data.user_info.profile);
                    setName(data.user_info.name);
                    setUserId(data.user_info.id);

                }

            } else {
                console.log('User info nÃ£o encontrado no localStorage');
            }
        } else {
            console.log('Dados nÃ£o encontrados no localStorage');
        }
    }, []);

    const fetchInfo = async (id_search) => {
        let list_route = api_list_route(getTokenInfo().companycode);

        return await reqGET(`${list_route}/${id_search}`)
            .then(res => {
                const task = res.data[0];
                const { prioridade, data_inicio, data_limite, estado } = task.info;

                setTarefaId(task.id);
                setNomeTarefa(task.info.name);
                setSelectedPrioridade(prioridade);
                setSelectedEstado(estado);
                setSelectedDataInicio(data_inicio);
                setSelectedDataLimite(data_limite);

                setNomeMonitor(getMonitorNome(task.info.monitor));
                setResponsaveisNome(getResponsaveisNome(task.info.responsaveis));

                set_dados(dados.current = task);

                setLoading(false);
            })
            .catch(() => 404);
    }; 
  
    useEffect(() => {
        const fetch_colaboradores = async () => {
            try {
                const res = await reqGET(Hosts.SIMCore_API + '/entities/list/' + getTokenInfo().companycode + '/Colaborador');

                const colaboradoresOptions = res.data.map(colaborador => ({
                    label: colaborador.name,
                    value: colaborador.id,
                    departamento: colaborador.departamento,
                    email: colaborador.email
                }));

                setAllResponsaveis(colaboradoresOptions);
            } catch (error) {
                console.error("Erro ao buscar os colaboradores:", error);
            }
        };
        fetch_colaboradores();
    }, []);

    useEffect(() => {
        if (allResponsaveis.length > 0 && departamentos.length > 0) {
            const responsaveisMap = {};

            // Iterar sobre cada colaborador
            allResponsaveis.forEach(colaborador => {
                colaborador.departamento.forEach(depto => {
                    // Se o departamento já existir no mapa, adicionamos o colaborador
                    if (!responsaveisMap[depto.id]) {
                        responsaveisMap[depto.id] = [];
                    }
                    // Adicionar um objeto com o id e o nome do colaborador
                    responsaveisMap[depto.id].push({ label: colaborador.label, value: colaborador.value, email: colaborador.email });
                });
            });

            // Agora temos um objeto com o ID do departamento como chave e os responsáveis como valor
            setResponsaveisPorDepartamento(responsaveisMap);
        }
    }, [allResponsaveis, departamentos]);

    useEffect(() => {
        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt');
            set_language('pt');
            set_lang_id('1');
        } else {
            set_lang(localStorage.getItem('lang'));
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id);
                }
            });
        }

        fetchInfo(props.location.state.item['id']).then(async () => {
            const lista_revs = await get_reviewers();
            reviewers.current = lista_revs;

            const lista_arts = await get_articles(props.location.state.item['id']);
            articles.current = lista_arts;

        });

    }, [props]);

    const get_reviewers = async () => {
        let aReviewers = [];

        return await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Revisor`)
            .then(res => {
                //console.log(res.data)

                res.data.forEach(v => {
                    aReviewers.push({ label: v.name, label2: v.surname, value: v.id })
                });

                //set_reviewers(aReviewers)
                return aReviewers
                //console.log('REVIEWERS', aReviewers)
            })
            .catch(erro => { console.log(erro); alert('Erro'); })
    }

    const get_articles = async (id) => {

        let aArticles = [];

        /* CHAMADA ARTIGOS */
        return await reqGET(`${api_crud_base}/tarefa/${getTokenInfo().companycode}`)
            .then(res => {
                //console.log(res.data)
                res.data.forEach(x => {
                    let aux = { id: x.id, title: x.info.title, cfp: x.info.id_cfp, reviewers: reviewers }

                    if (x.info.id_cfp === id) {
                        aArticles.push(aux);
                    }
                });
                return aArticles
            })

            .catch(erro => { console.log(erro); alert('Erro'); })
    }

    // Function to handle export logic
    const handleExport = () => {
        // Example export logic: exporting task data as JSON
        const exportData = {
            id: dados.current.id,
            name: dados.current.info.name,
            companycode: dados.info.companycode,
            prioridade: dados.info.prioridade,
            data_inicio: dados.info.data_inicio,
            data_limite: dados.info.data_limite,
            estado: dados.info.estado,
            departamento: dados.info.departamento,
            nomeMonitor: nomeMonitor,
            description: dados.current.info.description,
            solucao: dados.current.info.solucao,
            colaboradores: colaboradores.map(responsavel => responsavel.label).join('\n')
        };

        const json = JSON.stringify(exportData, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const url = URL.createObjectURL(blob);

        // Create a temporary link and trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = `tarefa_${dados.id}_relatorio.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url); // Clean up URL
    };

    // Function to handle print logic
    const handlePrint = () => {
        const printContent = document.getElementById('printable').innerHTML;
        const originalContent = document.body.innerHTML;

        document.body.innerHTML = printContent;
        window.print();

        document.body.innerHTML = originalContent;
    };

    const exportAllowed = true;
    const printAllowed = true;

    useEffect(() => {

        setLoading(false);

    }, [props]);

    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">{language[lang].loading}</h2>
                    <p>{language[lang].loading}</p>
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content"><span className="spinner"></span></div>
                        </div>
                    </div>
                </div>
            </main>
            :
            <main>
                <div className="opportunity-view" id="printable">
                    <div style={styles.container}>

                        {/* Header */}
                        <div style={styles.header}>
                            {data?.[0]?.info?.title?.[0]?.[lang] ||
                                data?.[0]?.info?.name ||
                                "Untitled"}
                        </div>

                        <div style={styles.section}>
                            <div style={styles.row}>
                                <div style={styles.gridItem}>
                                    <div style={styles.gridLabel}>{language[lang].createdBy}</div>
                                    <div style={styles.gridValue}>
                                        {data?.[0]?.info?.responsable?.create?.name || "-"}
                                    </div>
                                </div>
                                <div style={styles.gridItem}>
                                    <div style={styles.gridLabel}>{language[lang].last_update}</div>
                                    <div style={styles.gridValue}>
                                        {(() => {
                                            const execution = data?.[0]?.info?.responsable?.update?.execution
                                                ?? data?.[0]?.info?.edition_archive?.[0]?.responsables?.update?.execution;

                                            if (!execution) return '-';

                                            const d = new Date(execution);
                                            const day = String(d.getDate()).padStart(2, '0');
                                            const month = String(d.getMonth() + 1).padStart(2, '0');
                                            const year = d.getFullYear();
                                            const hours = String(d.getHours()).padStart(2, '0');
                                            const minutes = String(d.getMinutes()).padStart(2, '0');
                                            return `${day}/${month}/${year} ${hours}:${minutes}`;
                                        })()}
                                    </div>
                                </div>
                            </div>

                            <div style={styles.row}>
                                <div style={styles.gridItem}>
                                    <div style={styles.gridLabel}>{language[lang].amount}</div>
                                    <div style={styles.gridValue}>
                                        {data?.[0]?.info?.amount ? `${data?.[0]?.info?.amount} €` : "-"}
                                    </div>
                                </div>
                                <div style={styles.gridItem}>
                                    <div style={styles.gridLabel}>{language[lang].deadline}</div>
                                    <div style={styles.gridValue}>
                                        {data?.[0]?.info?.deadline
                                            ? (() => {
                                                const d = new Date(data[0].info.deadline);
                                                const day = String(d.getDate()).padStart(2, '0');
                                                const month = String(d.getMonth() + 1).padStart(2, '0');
                                                const year = d.getFullYear();
                                                const hours = String(d.getHours()).padStart(2, '0');
                                                const minutes = String(d.getMinutes()).padStart(2, '0');
                                                return `${day}/${month}/${year} ${hours}:${minutes}`;
                                            })()
                                            : "-"}
                                    </div>
                                </div>
                            </div>

                            <div style={styles.row}>
                                <div style={styles.gridItem}>
                                    <div style={styles.gridLabel}>{language[lang].company}</div>
                                    <div style={styles.gridValue}>
                                        {data?.[0]?.info?.contacts?.company?.name || "-"}
                                    </div>
                                </div>
                                <div style={styles.gridItem}>
                                    <div style={styles.gridLabel}>{language[lang].point_of_contact}</div>
                                    <div style={styles.gridValue}>
                                        {data?.[0]?.info?.contacts?.point_of_contact || "-"}
                                    </div>
                                </div>
                            </div>

                            <div style={styles.row}>
                                <div style={styles.gridItem}>
                                    <div style={styles.gridLabel}>{language[lang].email}</div>
                                    <div style={styles.gridValue}>
                                        {data?.[0]?.info?.contacts?.email || "-"}
                                    </div>
                                </div>
                                <div style={styles.gridItem}>
                                    <div style={styles.gridLabel}>{language[lang].tlm}</div>
                                    <div style={styles.gridValue}>
                                        {data?.[0]?.info?.contacts?.mobile_phone || "-"}
                                    </div>
                                </div>
                            </div>

                            <div style={styles.gridItem}>
                                {(data?.[0]?.info?.responsable?.update?.name ||
                                    data?.[0]?.info?.responsable?.update?.comBy?.name ||
                                    data?.[0]?.info?.description ||
                                    data?.[0]?.info?.stage?.label ||
                                    (Array.isArray(data?.[0]?.info?.edition_archive) && data[0].info.edition_archive.length > 0)) && (
                                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                            <thead>
                                                <tr style={{ borderBottom: '2px solid #ddd' }}>
                                                    <th style={{ ...styles.gridLabel, textAlign: 'left', padding: '6px 8px' }}>{language[lang].last_update}</th>
                                                    <th style={{ ...styles.gridLabel, textAlign: 'left', padding: '6px 8px' }}>{language[lang].comBy}</th>
                                                    <th style={{ ...styles.gridLabel, textAlign: 'left', padding: '6px 8px' }}>{language[lang].field_observations}</th>
                                                    <th style={{ ...styles.gridLabel, textAlign: 'left', padding: '6px 8px' }}>{language[lang].stage}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(data?.[0]?.info?.responsable?.update?.name ||
                                                    data?.[0]?.info?.responsable?.update?.comBy?.name ||
                                                    data?.[0]?.info?.description ||
                                                    data?.[0]?.info?.stage?.label) && (
                                                        <tr style={{ borderBottom: '1px solid #f0f0f0', backgroundColor: '#fafafa' }}>
                                                            <td style={{ ...styles.gridValue, padding: '6px 8px' }}>
                                                                {data?.[0]?.info?.responsable?.update?.name || '-'}
                                                                {data?.[0]?.info?.responsable?.update?.execution && (
                                                                    <div style={{ color: '#888', fontSize: '11px' }}>
                                                                        {data[0].info.responsable.update.execution.split('.')[0].replace('T', ' ')}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td style={{ ...styles.gridValue, padding: '6px 8px' }}>
                                                                {data?.[0]?.info?.responsable?.update?.comBy?.name || '-'}
                                                            </td>
                                                            <td style={{ ...styles.gridValue, padding: '6px 8px' }}>
                                                                {data?.[0]?.info?.description || '-'}
                                                            </td>
                                                            <td style={{
                                                                ...styles.gridValue,
                                                                padding: '6px 8px',
                                                                color: data?.[0]?.info?.stage?.color ?? '#555555',
                                                                fontWeight: '700'
                                                            }}>
                                                                {data?.[0]?.info?.stage?.label || '-'}
                                                            </td>
                                                        </tr>
                                                    )}

                                                {Array.isArray(data?.[0]?.info?.edition_archive) && data[0].info.edition_archive.map((el_ea, idx) => (
                                                    <tr key={el_ea.id ?? idx} style={{
                                                        borderBottom: '1px solid #f0f0f0',
                                                        backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa'
                                                    }}>
                                                        <td style={{ ...styles.gridValue, padding: '6px 8px' }}>
                                                            {el_ea?.responsables?.update?.name || '-'}
                                                            {el_ea?.responsables?.update?.execution && (
                                                                <div style={{ color: '#888', fontSize: '11px' }}>
                                                                    {el_ea.responsables.update.execution.split('.')[0].replace('T', ' ')}
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td style={{ ...styles.gridValue, padding: '6px 8px' }}>
                                                            {el_ea?.responsables?.update?.comBy?.name || '-'}
                                                        </td>
                                                        <td style={{ ...styles.gridValue, padding: '6px 8px' }}>
                                                            {el_ea?.description || '-'}
                                                        </td>
                                                        <td style={{
                                                            ...styles.gridValue,
                                                            padding: '6px 8px',
                                                            color: el_ea?.stage?.color ?? '#555555',
                                                            fontWeight: '700'
                                                        }}>
                                                            {el_ea?.stage?.label || '-'}
                                                        </td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className="nav-item">
                                    {exportAllowed && (
                                        <button className="btn btn-export btn-outline-primary mr-2" onClick={handleExport}>
                                            <i className="bi bi-download"></i> {language[lang].exportar_relatorio}
                                        </button>
                                    )}

                                    {printAllowed && (
                                        <button className="btn btn-print btn-outline-secondary" onClick={handlePrint}>
                                            <i className="bi bi-printer"></i> {language[lang].imprimir_relatorio}
                                        </button>
                                    )}

                                    {(permissions.current !== null && permissions.current.create) && (
                                        <Link className="nav-link" to={{ state: { item: { id: tarefaId }, operation: 'edit' }, pathname: endpoints.regist }} replace>
                                            <i className={icon.pencil2.className} style={icon.pencil2.style}></i>
                                            <span> {language[lang].edit}</span>
                                        </Link>
                                    )}

                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <i className="bi bi-arrow-left"></i>
                                        <span> {language[lang].back}</span>
                                    </Link>

                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </main>
}